export enum ConsentWrapperEvent {
  AcceptAll = 'accept-all',
  RejectAll = 'reject-all',
  SaveConsents = 'save-consents'
}
